<template>
  <v-card>
    <v-stepper v-model="e1" flat>
      <v-stepper-items>
        <v-stepper-content step="1" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="1">
            <v-card-title class="education_title">
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              <v-divider vertical class="hidden-md-and-up ml-2 mr-2 mx-2"></v-divider>
              <v-divider vertical class="hidden-sm-and-down ml-5 mr-5"></v-divider>
              <div class="red--text text--darken-2 education_title_notitext">출입 안전교육</div>
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2" style="overflow:auto;height:200px;">
              모두에게 가치 있는 최고의 파트너, <strong class="red--text text--lighten-1">{{$store.state.CustomInfo.SiteNm}}</strong> 방문을 환영합니다. <br>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" min-height="520" flat id="2">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주의사항 및 교육 안내</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 pb-0">
              <strong class="deep-orange--text">본 교육의 목적</strong><br>
              <span>
                {{ $store.state.CustomInfo.SiteNm }} 사내 규정 및 주의사항 등의 안전교육을 통한
              </span>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>내방객 및 협력사 인력에 대한 안전의식 고취</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                3.&nbsp;
                <div>사내 규정 교육을 통한 안전 작업 정착화</div>
              </div>
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></p>                
              <p class="ml-4 font-weight-bold body-1">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>                
              <p class="ml-4 font-weight-bold body-1">3. 사내 규정 교육을 통한 안전 작업 정착화</p>                 -->
              <!-- <div class="mb-2">{{$store.state.CustomInfo.SiteNm}} 사내 규정 및 주의사항 등의 안전교육을 통한</div>
              <p class="text-h6 font-weight-bold ml-4">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 사고 예방</p>
              <p class="text-h6 font-weight-bold ml-4">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>
              <p class="text-h6 font-weight-bold ml-4">3. 사내 규정 교육을 통한 안전 작업 정착화</p> -->
            </v-card-text>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">주의사항</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>서약서 동의 : 환경안전 서약서에 동의하여야 교육 수료가 완료됩니다.</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>진도율 : 교육내용은 처음부터 마지막까지 정독하셔야 진도율 100%가 달성됩니다.</div>
              </div>
              <!-- <p class="text-h6 font-weight-bold ml-4">1. 서약서 동의 : 환경안전 서약서에 동의하여야 교육 수료가 완료됩니다.</p>
              <p class="text-h6 font-weight-bold ml-4">2. 진도율 : 교육내용은 처음부터 마지막까지 정독하셔야 진도율 100%가 달성됩니다.</p> -->
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">교육 안내</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>인증 대상 : 내방객 / 관계사 / 협력사 전체</div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>
                  <div class="mb-2">인증 기간 : 교육 수료일로부터 6개월</div>
                  (인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)
                </div>
              </div>
              <!-- <p class="mt-n8 ml-8 mb-2 ml-4 text_first_font">(인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)</p>                 -->
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 인증 대상 : 내방객 / 관계사 / 협력사 전체</p>
              <p class="ml-4 font-weight-bold body-1">2. 인증 기간 : 교육 수료 일로부터 6개월</p>
              <p class="mt-n4 ml-8 font-weight-bold body-1">(인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)</p>                 -->
              <!-- <p class="text-h6 font-weight-bold ml-4">1. 인증 대상 : 내방객 / 관계사 / 협력사 전체</p>
              <p class="text-h6 font-weight-bold ml-4">
                2. 인증 기간 : 교육 수료 일로부터 6개월<br>
                (인증 유효기간 만료 시 본 시스템에 접속하여 갱신 교육을 받으셔야 합니다.)
              </p> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">Contents</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div>
              <div class="education_content flex-wrap d-flex justify-left mt-0 mb-0">
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">1.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">일반안전</strong>
                    <p class="mt-2 text_first_font">S.G.R(Safety Golden Rules)</p>
                    <p class="text_first_font">보행자 및 운전자 안전 수칙</p>
                    <p class="text_first_font">흡연 및 화재 예방 안전 수칙</p>
                    <p class="text_first_font">Penalty</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">2.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">공정 안전</strong>
                    <p class="mt-2 text_first_font">공정의 특징 및 안전 수칙</p>
                    <p class="text_first_font">화학물질 누출 시 대응 요령</p>
                    <p class="text_first_font">안전 보호구</p>
                    <p class="text_first_font">중량물 취급 안전</p>
                    <p class="text_first_font">안전표지</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2 d-flex">
                  <strong class="deep-orange--text">3.&nbsp;</strong>
                  <div>
                    <strong class="deep-orange--text">안전 작업 허가제</strong>
                    <p class="mt-2 text_first_font">허가 절차</p>
                    <p class="mt-2 text_first_font">공구 검수</p>
                  </div>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">4. 안전 작업 수칙</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">5. 비상 대응 절차(비상 대피 등)</strong><br>
                </div>
                <div class="ma-4 mb-0 lineHeight2">
                  <strong class="deep-orange--text">6. 준수 서약서</strong><br>
                </div>

              </div>
              <v-card-text class="text-h5 lineHeight2 text-center iron_center_contents" style="margin-top: 80px;">
                <!-- <div v-if="$store.state.CustomInfo.SiteId != 'SKTC' && $store.state.CustomInfo.SiteId != 'SKMG14'" class="iron_center_contents" style="width:inherit; height:350px;">
                  <img src="../assets/fire_center_logo.png" style="height:300px"/>
                </div> -->
                <!-- <div v-if="$store.state.CustomInfo.SiteId =='SKTC'" class="iron_center_contents ml-4 mt-5 text_first_font">
                  <img src="../assets/SKTC.svg" style="height:300px"/>
                </div> -->
                
                
                
              </v-card-text>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" min-height="520" flat id="4">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">S.G.R(Safety Golden Rules) 준수항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2">
              사업장 내에서 <strong class="red--text text--lighten-1">반드시 지켜야 할 10대 S.G.R(Safety Golden Rules)</strong><br>
            </v-card-text>
            <v-divider></v-divider>

            
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>Safety Golden Rules</strong><br>
            </v-card-text>
            

            <v-card-text class="education_content lineHeight2">
              <div class="d-flex red--text">
                1.&nbsp;
                <div>유해 위험물질 취급/작업 時 지정된 보호구 착용 (위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>사고 보고 기준 준수(즉시 보고/서면 보고)</div>
              </div>
              <div class="d-flex red--text">
                3.&nbsp;
                <div>작업 時 작업허가서 승인 후 작업(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex red--text">
                4.&nbsp;
                <div>밀폐작업 時 산소농도/유해가스 측정(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex red--text">
                5.&nbsp;
                <div>고소지역 작업 時 추락 예방 조치 후 작업(위반 시 6개월 출입 금지)</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>변경 관리 절차 준수 (변경 검토, 가동 전 점검)</div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>지정된 장소 外 금연 (라이터 휴대 금지)</div>
              </div>
              <div class="d-flex">
                8.&nbsp;
                <div>사내 운송수단 안전 수칙 준수</div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 보행자 및 운전자 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">보행자가</strong> 꼭 지켜야 할 사항<br>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      1.&nbsp;
                      <div>인도 보행 준수</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>횡단보도 생활화</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>야간, 새벽 보행 시 가급적 밝은색 의복 착용</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>건널목 통행 시 좌, 우 확인 후 통행</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>음주 후 사내 출입 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      6.&nbsp;
                      <div>차량 바로 앞/뒤 보행 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      7.&nbsp;
                      <div>공사 현장 내 출입 및 접근금지</div>
                    </div>
                  </div>
                  <p class="iron_center_contents"><img src="../assets/under-construction.jpg" style="height:200px; border-radius: 10px;"></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <strong class="red--text text--lighten-1">운전자가</strong> 꼭 지켜야 할 사항<br>
                  <p class="mt-2 ml-4 text_first_font">1. 사내 규정 속도 준수</p>
                  <p class="ml-4 text_first_font">공장 내 (20km) 공장 외(30km)이내</p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      ※&nbsp;
                      <div>위반 시 <strong class="red--text text--lighten-1">"출입 정지"</strong> 등 규정에 따름</div>
                    </div>
                  </div>

                  <p class="iron_center_contents"><img src="../assets/traffic-light.png" style="height:80px"></p>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      2.&nbsp;
                      <div>주ㆍ정차 구역 外 주차금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      3.&nbsp;
                      <div>방지턱 우회 운행 및 앞지르기 금지</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      4.&nbsp;
                      <div>방향 전환 시 방향 지시등 점등</div>
                    </div>
                  </div>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <div class="d-flex">
                      5.&nbsp;
                      <div>차내 흡연 및 휴대전화 사용금지</div>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="6" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - 흡연 및 화재 예방 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              {{$store.state.CustomInfo.SiteNm}} 단지 내 <strong class="red--text text--lighten-1">화재 예방 안전 방침</strong>을 안내하오니 적극 협조 이행 바랍니다.
            </v-card-text>
            <v-divider class="ma-3"></v-divider>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              1. <strong class="red--text text--lighten-1">보행 중</strong> 흡연 <strong class="red--text text--lighten-1">금지</strong>되어 있습니다.<br>
              2. 담배는 <strong class="red--text text--lighten-1">지정된</strong> 흡연 장소에서만 피운다.<br>
              3. 담배꽁초를 <strong class="red--text text--lighten-1">아무 데나</strong> 버리는 행동을 하지 않는다.<br>
              4. 담뱃불은 손가락으로 <strong class="red--text text--lighten-1">튕기지</strong> 않는다.<br>
              5. 불이 <strong class="red--text text--lighten-1">덜 꺼진</strong> 담배꽁초를 쓰레기통에 버리지 않는다.<br>
            </v-card-text>
            <div class="iron_center_contents mt-5"><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"/></div> -->

            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><span class="red--text text--lighten-1">보행 중</span> 흡연 <span class="red--text text--lighten-1">금지</span>되어 있습니다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>담배는 <span class="red--text text--lighten-1">지정된</span> 흡연 장소에서만 피운다.</div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>담배꽁초를 <span class="red--text text--lighten-1">아무 데나</span> 버리는 행동을 하지 않는다.</div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>담뱃불은 손가락으로 <span class="red--text text--lighten-1">튕기지</span> 않는다.</div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>불이 <strong class="red--text text--lighten-1">덜 꺼진</strong> 담배꽁초를 쓰레기통에 버리지 않는다.</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <div class="iron_center_contents "><img src="../assets/no-smoking.png" style="height:200px; border-radius: 10px;"></div>    
              </v-col>
            </v-row>
            <v-divider class="ma-3"></v-divider>
            <v-card-text>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div st>흡연 적발자는 <strong class="red--text text--lighten-1">관계사 통보</strong> 및 사전 경고 없이 <strong class="red--text text--lighten-1">퇴출, 각서징구</strong> 등 불이익 처리가 따릅니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <div>담뱃불(약 500˚C) 특성상 <strong class="red--text text--lighten-1">실효습도 50% 이하</strong>에는 대기 중에서 <strong class="red--text text--lighten-1">인화</strong>하기 쉽습니다.</div>
              </div>
              <div class="d-flex text_first_font mb-3">
                <div>※</div>
                <template>
                  <div>
                    화재 등 {{$store.state.CustomInfo.SiteNm}} 신고 전화는
                    <strong class="red--text text--lighten-1">054-630-8119</strong>입니다.
                  </div>
                </template>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="7" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">일반안전 - Penalty</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>GOLDEN RULE을 기본으로, 즉시 Penalty 적용<br></strong>
              <strong class="red--text text--lighten-1">작업자 위반사항 발생 시 경고 없이 즉시 적용 : 개인 출입 정지 및 업체 평가 반영</strong><br>
            </v-card-text>

            <div class="text_first_font hidden-sm-and-down mb-2">
              <div class="d-flex">
                SGR위반 Penalty세부기준
                <v-spacer></v-spacer>
                <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
              </div>
            </div>
            <div class="text_first_font hidden-md-and-up mb-2">
              SGR위반 Penalty세부기준<br>
              <strong class="red--text text--lighten-1">※SGR 외 위반사항은 벌점제로 운영</strong>
            </div>

            <table class="type09 text-center">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">구성원</th>
                  <th scope="cols">협력업체 직원</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1차 위반</td>
                  <td>위반자 경고<br><strong class="indigo--text">(팀장)</strong></td>
                  <td>협력업체 대표가<br>위반자 경고/<strong class="indigo--text">안전교육 실시</strong><br><strong class="indigo--text">협력업체 관리부서 통보</strong></td>
                </tr>
                <tr>
                  <td>2차 위반</td>
                  <td>위반자 경고<br><strong class="indigo--text">(공장장/실장)</strong></td>
                  <td>[직원] 6개월 출입 금지<br><strong class="indigo--text">협력업체 관리부서 통보</strong></td>
                </tr>
                <tr>
                  <td>3차 위반</td>
                  <td>인사(소) 위원회 회부<br><strong class="indigo--text">(공장장/실장)</strong></td>
                  <td>[직원] 영구 출입 금지<br>[회사] 업체 대표 면담 <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SHE 평가 반영</td>
                </tr>
                <tr>
                  <td>기타</td>
                  <td colspan='2' class="text-left">
                    <strong class="indigo--text d-flex mb-4">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>SGR 위반으로 사고 발생 시 즉시 제재</div>
                    </strong>
                    <strong class="indigo--text d-flex">
                      <v-icon color="indigo" class="align-self-start">mdi-check</v-icon>
                      <div>
                        누적 기한 : 발생일로부터 2년 혹은 1년간 유효하다.<br>
                        (SGR : <strong class="red--text text--lighten-1">2</strong>년, 일반안전 수칙 : <strong class="red--text text--lighten-1">1</strong>년)
                      </div>
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="8">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 특징 및 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">공정의 특징</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">안전 보호구 반드시 착용</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>공정 내 화학물질 누출시 화재위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">비상 대피로 파악</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>배관 / 설비에 의한 충돌 및 전도 위험<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">보행 시 전방 주시</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">사물을 멀리 보고 심호흡</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼<v-icon>mdi-arrow-right</v-icon><span class="red--text text--lighten-1">상시 안전에 유의</span></div>
                </div>
              </div>
              <!-- <strong class="text-h6">1. 화학약품(Gas, Chemical) 누출 시 피부 접촉 및 흡입의 위험성</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">안전 보호구 반드시 착용</strong><br>
              <strong class="text-h6">2. 공정 내 취급 가스 누출 시 화재위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">비상 대피로 파악</strong><br>
              <strong class="text-h6">3. 배관 / 설비에 의한 충돌 및 전도 위험</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">보행 시 전방 주시</strong><br>
              <strong class="text-h6">4. 내산복 /방독면 등 보호구 착용으로 거동 불편 / 심리적 불안</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">사물을 멀리 보고 심호흡</strong><br>
              <strong class="text-h6">5. 다수의 인원이 근무하므로 화재, 가스누출 등 각종 사고 발생 시 피해가 큼</strong> <v-icon>mdi-arrow-right</v-icon> 
              <strong class="text-h5 red--text">상시 안전에 유의</strong> -->
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">공정 내 안전 수칙</strong><br>
              <!-- text_first_font -->
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>당사 관리감독자의 지시에 따를 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>업무와 연관이 없는 각종 설비, 장비의 임의 조작을 금지할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>"출입 금지", "통제구역"은 출입하지 않는다.</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>Eye & Body Shower 위치를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비상 대피로 및 비상 전화번호를 숙지하여 비상시 긴급 대응할 것</div>
                </div>
                
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="9">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질(Gas/Chemical)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">Gas, Chemical 누출을 조기 감지하고자</strong><br>
              <p class="ml-4 mt-2 text_first_font"> 독성 / 가연성 Gas, Chemical의 경우 공정 내 가스검지기 설치 운용 중</p>
              <p class="ml-4 text_first_font"> 모든 감지기는 모니터링되고 있으며, 감지기 동작 시 즉시 현장 확인 조치</p>
              <p class="ml-4 text_first_font"> 작업자가 직접 누출을 목격하거나, 냄새 발생으로 인지할 시 반드시 신고하여야 함</p>
            </v-card-text>
            <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_01.jpg" style="height:200px; border-radius: 10px;"></div>보거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_02.jpg" style="height:200px; border-radius: 10px;"></div>냄새 맡거나
              </div>
              <div class="ma-4 text-center font-weight-black">
                <div class="iron_center_contents"><img src="../assets/safe_camical_03.jpg" style="height:200px; border-radius: 10px;"></div>감지기가 작동하거나
              </div>

            </div>
            
            
            
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="10">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - HF(불화수소)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">HF (불화수소)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">자료 없음</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">자료 없음</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">0.997</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">19.5℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">HF</td>
                      <td class="table_line_right">Hydrogen Fluoride</td>
                      <td class="table_line_right">7664-39-3</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 0.5 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_1.svg" style="height:100px; border-radius: 10px;margin-right : 15px;">
                          <img src="../assets/graph_1.svg" style="height:120px;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">물과 접촉을 피할 것</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">밀폐용기에 보관할 것</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>피부에&nbsp;<span class="red--text text--lighten-1">심한 화상</span>을 일으킴.</div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>눈에 심한 손상을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입하면 치명적임
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>피부, 눈, 점막, 폐 등에 손상을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>약한 상처는 바로 나타나지 않지만 수 시간 후에 통증이 생길 수 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="11">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - NF3(삼불화질소)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">NF<sub>3</sub> (삼불화질소)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">해당없음</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_02.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">해당없음</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">증기밀도 2.5</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">-129 ~ 120℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">NF<sub>3</sub></td>
                      <td class="table_line_right">트리블루오르화 질소</td>
                      <td class="table_line_right">7783-54-2</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 10 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_2.svg" style="height:100px; border-radius: 10px;margin-right : 15px;">
                          <img src="../assets/graph_2.svg" style="height:120px;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">점화원 및 열과의 접촉 금지<br>구리스, 오일과 접촉 금지</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">용기가 전도되지 않도록 조치<br>서늘하고 건조한 장소에 보관</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>허용농도&nbsp;:&nbsp;<span class="blue--text">10 ppm, 30mg/m<span class="superscript">3</span></span></div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>고압가스이며 가열시 폭발할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <div class="d-flex align-start">
                      <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                      <div>산화제(오일, 구리스 등), 가연성 물질과 접촉하면&nbsp;<span class="red--text text--lighten-1">발화되거나 폭발할 수 있음</span></div>
                    </div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입 시 유해할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입 시 현기증이 일어날 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>장기간 또는 반복적으로 노출되면 장기에 손상을 일으킬 수 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="12">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - SiH4(실란)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">SiH<sub>4</sub> (실란)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">자연발화</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">-50℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">증기밀도 1.3</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">-112℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">SiH<sub>4</sub></td>
                      <td class="table_line_right">모노실란, 실레인</td>
                      <td class="table_line_right">7803-62-5</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 5 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크, 귀마개</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_3.svg" style="height:100px; border-radius: 10px;margin-right : 15px;">
                          <img src="../assets/graph_3.svg" style="height:120px;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내열성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">방염재질, 내열성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">점화원 및 열과의 접촉 금지</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">용기가 전도되지 않도록 조치<br>서늘하고 건조한 장소에 보관</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>허용농도&nbsp;:&nbsp;<span class="blue--text">5ppm, 7mg/m<span class="superscript">3</span></span></div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>공기 중 노출시&nbsp;<span class="red--text text--lighten-1">자연발화</span> 되는 가스임</div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>고압가스이며 가열시 폭발할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>피부 접촉 시 자극을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>눈에 접촉 시 심한 자극을 일으킴
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>흡입 시 호흡기계 자극을 일으킬 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>장기간 또는 반복적으로 노출되면 장기에 손상을 일으킬 수 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="13">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - WF6(육불화텅스텐)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">WF<sub>6</sub> (육불화텅스텐)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">해당없음</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_09.png" style="height:80px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">해당없음</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">증기밀도 10.3</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">18 ~ 20℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">WF<sub>6</sub></td>
                      <td class="table_line_right">텅스텐 플로라이드</td>
                      <td class="table_line_right">7803-82-6</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 5 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_4.svg" style="height:100px; border-radius: 10px;margin-right : 15px;">
                          <img src="../assets/graph_4.svg" style="height:120px;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">직접적인 접촉을 피할 것<br>취급 담당자만 취급</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">용기가 전도되지 않도록 조치<br>환기가 되는 장소에 보관</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="14">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">주요 화학물질의 위험성 - NH3(암모니아)</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="8" sd="12">
                <v-card-text class="education_content lineHeight2 pa-0">
                  <strong class="deep-orange--text">NH<sub>3</sub> (암모니아)</strong>
                </v-card-text>
                <table class="type11 text-center">
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='7' class="pt-0">물질 특성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">물성</td>
                      <td class="table_line_right">인화점</td>
                      <td class="table_line_right">11℃</td>
                      <td class="table_line_right" rowspan="4">유해/위험 분류</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex">
                          <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_10.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/warn_11.png" style="height:80px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">자연발화점</td>
                      <td class="table_line_right">651℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">비중</td>
                      <td class="table_line_right">0.59</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">끓는점</td>
                      <td class="table_line_right">-33℃</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2" colspan="2">구성 성분 명칭 및 함유량</td>
                      <td class="table_line_right">화학물질명</td>
                      <td class="table_line_right">관용명 및 이명</td>
                      <td class="table_line_right">CAS. No</td>
                      <td class="table_line_right">함유량</td>
                      <td>노출기준</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">NH<sub>3</sub></td>
                      <td class="table_line_right">무수 암모니아</td>
                      <td class="table_line_right">7664-41-7</td>
                      <td class="table_line_right">100%</td>
                      <td>TWA 25 ppm</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr class="text_first_font">
                      <th scope="cols" colspan='4'>예방 / 안전 조치 요령</th>
                      <th scope="cols" colspan='3'>NFPA CODE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table_line_right" rowspan="4">보호구</td>
                      <td class="table_line_right">개인보호구</td>
                      <td class="table_line_right" colspan="2">방독 마스크</td>
                      <td rowspan="4" colspan="3">
                        <div class="d-flex align-center justify-center">
                          <img src="../assets/graph-text_5.svg" style="height:100px; border-radius: 10px;margin-right : 15px;">
                          <img src="../assets/graph_5.svg" style="height:120px;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">눈 보호</td>
                      <td class="table_line_right" colspan="2">보안경, 고글</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">손 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호장갑</td>
                    </tr>
                    <tr>
                      <td class="table_line_right">신체 보호</td>
                      <td class="table_line_right" colspan="2">내화학성 보호의</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" colspan="2">공학적 관리</td>
                      <td class="table_line_right" colspan="2">국소배기, 환기 장치</td>
                      <td class="text_first_font" style="font-weight: bold;" colspan="3">보호구 / 예방 / 안전설비</td>
                    </tr>
                    <tr>
                      <td class="table_line_right" rowspan="2">취급/저장 방법</td>
                      <td class="table_line_right">취급</td>
                      <td class="table_line_right" colspan="2">화기와의 접촉을 피할 것</td>
                      <td rowspan="2" colspan="3" class="img_area">
                        <div class="d-flex flex-wrap">
                          <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:80px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_07.svg" style="height:65px; border-radius: 10px;"></div>
                          <div class="iron_center_contents"><img src="../assets/guide_06.svg" style="height:65px; border-radius: 10px;"></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table_line_right">저장</td>
                      <td class="table_line_right" colspan="2">밀폐용기에 보관할 것</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="4" sd="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <span class="red--text text--lighten-1">극인화성 가스</span>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>
                    <div>고압가스이며, <span class="red--text text--lighten-1">가열하면 폭발</span>할 수 있음</div>
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>고온에서 분해되어 독성가스를 생성할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>가열시 용기가 폭발할 수 있음
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>물에 녹으며 열을 발생함
                  </div>
                  <div class="d-flex align-start">
                    <v-icon class="mr-1 mt-3">mdi-arrow-right</v-icon>증기는 매우 자극적이고 부식성이 있음
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="15">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화학사고 발생 시</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">화학사고 발생 시 대피 요령</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>독성가스는 대부분 공기보다 무겁기 때문에 낮은 곳보다는 <span class="red--text text--lighten-1">높은 곳으로 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>바람은 독성물질을 운반하는 역활을 하므로 반드시 <span class="red--text text--lighten-1">바람을 거슬러 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동하려는 방향에서 가스가 날아오는 경우 <span class="red--text text--lighten-1">바람이 부는 방향의 직각으로 이동</span></div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>화학물질에 노출되었다면 즉시 병원에 가서 <span class="red--text text--lighten-1">의사의 진찰을 받아야 함</span></div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>지하철 등 실내 공간에서는 <span class="red--text text--lighten-1">신속히 실외로 대피</span></div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">화학물질 접촉 시 행동 요령</strong><br>
              <div class="text_first_font mb-4 2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>즉시 당사 <span class="red--text text--lighten-1">직원에게 통보</span></div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>흐르는 물로 15분 이상 씻고 오염된 옷 또는 장갑류는 벗을 것
                    <div class="mt-2">- 초기 증상 없음 : 물과 비누로 피부 오염부위 세척</div>
                    <div class="mt-1 mb-2">- 진행(붓기, 물집 등) : 흐르는 물로 가볍게 씻을 것</div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>경미한 접촉이라도 <span class="red--text text--lighten-1">즉시 방제센터로 신고</span> 하시기 바랍니다.</div>
                </div>
              </div>
              <!-- <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/fire_center_logo.png" style="height:300px"/></div> -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="16" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="16">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 화학물질 누출 시 대응 요령</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 text-center">
              <strong class="red--text text--lighten-1">안전 보호구</strong>
              는 필히
              <strong class="red--text text--lighten-1">착용</strong>
              하고
              <strong class="red--text text--lighten-1">작업</strong>
            </v-card-text>
            
            <table class="type09 text-center">
            <!-- <table class="type09 text-center text-subtitle-1 font-weight-medium"> -->
              <thead>
                <tr>
                  <th scope="cols">구분</th>
                  <th scope="cols">Action</th>
                  <th scope="cols">PPE(보호구)</th>
                </tr>
              </thead>
              <tbody class="text_first_font">
                <tr>
                  <td>신고</td>
                  <td class="text-left">
                    <span>
                      Chemical 누출 사고 발생 시 방재센터(054-630-8119)로 신고한다.
                    </span>
                    <br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>신고 시 누출 명 및 누출 정도, 장소를 정확히 신고</div>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>약품 접촉 시</td>
                  <td class="text-left">Chemical 누출 접촉 시 즉시 흐르는 물에 15분 이상 씻고, 관리감독자 지시에 따라 의료기관으로 후송</td>
                  <td><strong class="red--text text--lighten-1">비상 샤워기</strong></td>
                </tr>
                <tr>
                  <td>공급원 차단</td>
                  <td class="text-left">누출 공급원을 차단하여 추가적인 누출을 막는다.</td>
                  <td><strong class="red--text text--lighten-1">내산복, 내산장갑, 내산장화 착용<br>전면방독면 착용</strong></td>
                </tr>
                <tr>
                  <td>확산 방지 조치</td>
                  <td class="text-left">누출원 확산 방지에 주력한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>사고지점 출입 통제 및 방호조치</div>
                    </div>
                  </td>
                  <td>흡착 펜스 or 흡착포<br>
                  (유독) 가스 발생 시:배풍기 설치</td>
                </tr>
                <tr>
                  <td>누출원 수거</td>
                  <td class="text-left">
                    누출된 Chemical을 수거한다.<br>
                    <div class="d-flex">
                      -&nbsp;
                      <div>다량 누출 시 (Chemical 수거기 이용)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>소량 누출 시 (흡착포 사용)</div>
                    </div>
                  </td>
                  <td>Chemical 수거기, 흡착포</td>
                </tr>
                <tr>
                  <td>폐기물 처리</td>
                  <td class="text-left">
                    폐 흡착 펜스 및 흡착포 비닐 포장 & 전용 수거 용기 사용 수거<br>
                    <strong class="red--text d-flex">
                      ※&nbsp;
                      <div>폐기물 처리 절차에 의한 폐기실시</div>
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="17" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="17">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정안전 - 작업 종류별 보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <table class="type09 text-center text_first_font">
              <thead>
                <tr>
                  <th scope="cols">구 분</th>
                  <th scope="cols">착용 보호구</th>
                  <th scope="cols">사 진</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div> 
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                  </td>
                </tr>
                <tr>
                  <td>Gas 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>방독면(전면, 반면)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>내산복, 내산장갑, 내산장화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>방염복</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_2.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_3.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_4.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_10.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                  </td>
                </tr>
                <tr>
                  <td>전기 취급</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안면</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>절연계 보호구(절연장감, 절연화 등)</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>감전 장비</div>
                    </div>
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_7.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_8.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_9.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                  </td>
                </tr>
                <tr>
                  <td>그외 지역</td>
                  <td class="text-left">
                    <div class="d-flex">
                      -&nbsp;
                      <div>안전모, 안전화, 보안경, 방독면(반면/휴대)
                      </div>
                    </div>

                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>안전화</div>
                    </div>
                    <div class="d-flex">
                      -&nbsp;
                      <div>보안경</div>
                    </div> -->
                    <!-- <div class="d-flex">
                      -&nbsp;
                      <div>방독면(반면/휴대)</div>
                    </div> -->
                  </td>
                  <td class="text-left">
                    <img src="../assets/safe_tool_0.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_1.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <img src="../assets/safe_tool_6.jpg" style="height:70px; border-radius: 10px;" class="mr-2">
                    <!-- <img src="../assets/safe_tool_5.jpg" style="height:70px; border-radius: 10px;" class="mr-2"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="18" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="18">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 작업 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row clas="ma-0">
              <v-col cols="12" md="6" sd="12">
                <v-card-text class="lineHeight2 grey--text text--darken-1">
                  <div class="education_content d-flex mb-2">
                    1.&nbsp;
                    <div>안전 작업 <strong class="red--text text--lighten-1">허가 승인</strong> 절차 준수(JSA 포함)</div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      2.&nbsp;
                      <div>허가 승인 검수 준수</div>
                    </div>
                    <div class="red--text ml-6 text_first_font">[전기릴선, 용접기, 그라인더, 절단기, 사다리 등]</div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      3.&nbsp;
                      <div>작업 반경 內 <strong class="red--text text--lighten-1">방호조치</strong> 철저</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>교통통제 요원, 신호수, 작업지휘자 배치</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업구획(펜스, 라바콘 설치), 공사 안전 표지판 설치 및 안전 작업허가서 게시</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>장비 이동 전용 안전 받침대 사용, 크레인 전용 받침목, 차량 고임목 설치</div>
                    </div>
                  </div>
                  <div class="mb-2 education_content">
                    <div class="education_content d-flex mb-2">
                      4.&nbsp;
                      <div>작업 주관부서 관리감독자 현장 상주</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 전:작업순서 및 그 순서마다 작업 방법을 정하고 작업을 지휘할 것, 보호구 및 기구, 공구 점검, 정비할 것</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>작업 중:관계 작업자 이외 출입 금지, 보호구 착용 상태를 점검할 것</div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="education_content d-flex mb-2">
                      5.&nbsp;
                      <div>작업 안전 보호구 착용</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(지상 작업 시) 안전모, 안전화, 보안경, 방독면(휴대)</div>
                    </div>
                    <div class="ml-6 text_first_font d-flex">
                      -&nbsp;
                      <div>(고소작업 시)해당 보호구 별도 착용</div>
                    </div>
                  </div>
                  <div class="education_content d-flex mb-2">
                    6.&nbsp;
                    <div>기상 이상 시 <strong class="red--text text--lighten-1">작업 중지</strong> 기준(방제센터에서 기상정보 확인)</div>
                  </div>
                </v-card-text>
                
                <table class="type09 text-center ">
                  <thead>
                    <tr class="text_first_font hidden-xs-only">
                      <th scope="cols">강우량<br>(mm/hr)</th>
                      <th scope="cols">강설량<br>(cm/hr)</th>
                      <th scope="cols">순간 최대<br>풍속(m/sec)</th>
                      <th scope="cols" style="min-width:100px;">작업기준</th>
                    </tr>
                      <!-- <th scope="cols" class="" style="max-width:10px">작업기준</th>
                      <th scope="cols" class="" style="max-width:10px">작업기준</th> -->

                    <tr class="text_first_font d-sm-none">
                      <th scope="cols" style="max-width:20px;">강우량<br>(mm/hr)</th>
                      <th scope="cols" style="max-width:20px;">강설량<br>(cm/hr)</th>
                      <th scope="cols">순간 최대<br>풍속(m/sec)</th>
                      <th scope="cols" style="">작업기준</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan='3'>1.0 이상</td>
                      <td rowspan='3'>1.0 이상</td>
                      <td>8 이상 ~ 11 미만</td>
                      <td>외부 용접, 도장 작업 중지</td>
                    </tr>
                    <tr>
                      <td>11 이상 ~ 15 미만</td>
                      <td>적재, 건립 작업 중지</td>
                    </tr>
                    <tr>
                      <td>15 이상</td>
                      <td>모든 고소 작업 중지</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" md="6" sd="12">
                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">크레인 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_1.png" class="flow_picture_type1">
                  </div>
                </div>

                <div class="iron_center_contents" style="width:inherit; height:50px;">
                  <div style="width:inherit; background-color: #F44336; text-align: center; color:white; border-radius: 5px; padding: 2px;">지게차 안전 수칙</div>
                </div>
                <div>
                  <div class="iron_center_contents" style="width:inherit; height:300px;">
                    <img src="../assets/safe_car_2.png" class="flow_picture_type1">
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="19" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="19">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">공정 안전 - 중량물 운반 시 안전 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 인력 운반 시 재해 발생 형태</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>염좌 : 중량물을 무리하게 또는 갑작스럽게 들어 올리거나 운반 시 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>협착 : 중량물을 들어 올리거나 내릴 때 손 또는 발이 취급 중량물과 지면 또는 건축물 등에 끼어 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>낙하 : 중량물을 들어 올리거나 운반하다가 힘에 겨워 중량물을 떨어뜨려 발생</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>충돌 : 물건을 운반하는 중에 다른 사람과 부딪혀서 발생</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 ">
              <strong class="deep-orange--text">운반 재해예방의 기본원칙</strong>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>작업공정을 개선하여 운반의 필요성이 없도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반작업을 줄인다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반회수(빈도) 및 거리를 최소화, 최단거리화한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>중량물의 경우 2~3인이 운반하도록 한다.</div>
              </div>
              <div class="ml-5 mt-2 mb-2 text_first_font d-flex">
                -&nbsp;
                <div>운반 보조 기구 및 기계를 이용한다.</div>
              </div>
            </v-card-text>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">중량물 운반 시 올바른 자세 및 방법</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move01.png" style="height:160px; border-radius: 10px;"></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">1</div>무게 중심을 확인한다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move02.png" style="height:160px; border-radius: 10px;"></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">2</div>가까이 선다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move03.png" style="height:160px; border-radius: 10px;"></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">3</div>쪼그려 앉는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move04.png" style="height:160px; border-radius: 10px;"></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">4</div>안정되게 잡는다.
                  </div>
                </div>
                <div>
                  <div class="iron_center_contents"><img src="../assets/safe_move05.png" style="height:160px; border-radius: 10px;"></div>
                  <div class="d-flex ma-4">
                    <div class="circle_Box mr-2">5</div>다리를 이용해 들어 올린다.
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="20" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="20">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">금지표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_01.png" style="height:120px; border-radius: 10px;"></div>출입 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_02.png" style="height:120px; border-radius: 10px;"></div>보행 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_03.png" style="height:120px; border-radius: 10px;"></div>차량 통행금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_04.png" style="height:120px; border-radius: 10px;"></div>사용금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_05.png" style="height:120px; border-radius: 10px;"></div>탑승 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_06.png" style="height:120px; border-radius: 10px;"></div>금연
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_07.png" style="height:120px; border-radius: 10px;"></div>화기 금지
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/safe_08.png" style="height:120px; border-radius: 10px;"></div>물체 이동금지
                </div>
              </div>
            </v-card-text>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">경고표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_01.png" style="height:120px; border-radius: 10px;"></div>인화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_02.png" style="height:120px; border-radius: 10px;"></div>산화성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_03.png" style="height:120px; border-radius: 10px;"></div>폭발성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_04.png" style="height:120px; border-radius: 10px;"></div>급성 독물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_05.png" style="height:120px; border-radius: 10px;"></div>부식성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_06.png" style="height:120px; border-radius: 10px;"></div>방사성 물질
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_07.png" style="height:120px; border-radius: 10px;"></div>고압전기
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/warn_08.png" style="height:120px; border-radius: 10px;"></div>위험장소
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="21" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="21">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">지시표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_01.png" style="height:120px; border-radius: 10px;"></div>보안경 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_02.png" style="height:120px; border-radius: 10px;"></div>방독마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_03.png" style="height:120px; border-radius: 10px;"></div>방진 마스크 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_04.png" style="height:120px; border-radius: 10px;"></div>보안면 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:120px; border-radius: 10px;"></div>안전모 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_06.png" style="height:120px; border-radius: 10px;"></div>귀마개 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:120px; border-radius: 10px;"></div>안전화 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_08.png" style="height:120px; border-radius: 10px;"></div>안전 장갑 착용
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_dir_09.png" style="height:120px; border-radius: 10px;"></div>안전복 착용
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안내표지</strong>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_01.png" style="height:120px; border-radius: 10px;"></div>녹십자
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_02.png" style="height:120px; border-radius: 10px;"></div>응급구호
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:120px; border-radius: 10px;"></div>들것
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:120px; border-radius: 10px;"></div>세안 장치
                </div>
                <div class="ma-4 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/guide_05.png" style="height:120px; border-radius: 10px;"></div>비상구
                </div>
              </div> 
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="22" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">안전 공구 검수 Process</strong>

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>안전공구<br>목록 제출</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">2</strong><br>현장 작업<br>물품 검수</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">3</strong><br>안전 필증<br>부착</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">4</strong><br>작업 현장<br>물품 사용</div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="text_first_font lineHeight2">
              <strong class="text-h5 deep-orange--text font-weight-black">주요 검수 물품 대상</strong> 
              <v-row class="ma-0 mb-2">
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>사다리</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기 그라인더, 절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고속절단기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>가스용접기</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>고소 작업대</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기릴선</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>벨트를 이용한 회전 장치(공기압축기 등)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>전기드릴(휴대용, 탁상용)</div></v-col>
                <v-col cols="12" md="4" sd="6"><div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>기타(안전상 위험이 있다고 판단되는 물품)</div></v-col>
              </v-row>
              ※ 공구 검수 장소 : 해당 현장
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="23" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="23">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">사다리</strong>
              <v-row class="mt-n15">
                <v-col cols="12" md="3">
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_01.jpg" style="height:180px; border-radius: 10px;"></div>
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                  <!-- <table class="type09 text-center subtitle-1 font-weight-bold"> -->
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>바닥 고정장치 <br>(미끄럼 방지 장치)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>플라스틱 또는 고무 재질의 보호 Cap 설치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외형상 보호용 Cap의 손상이 없을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>사다리 고정장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>A자, L자 전개 후 고정장치 체결 시 유동이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>외관상 휘어짐 등의 변형이 없을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>Push Type의 경우 누른 부위와 고정 부위가 일치할 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>아웃트리거(Outtrigger)가 설치되어 있을 것</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>발판</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 폭 : 30cm 이상이 될 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판 끝에는 미끄럼 방지 조치가 되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>발판의 휘어짐이나 변형이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3">
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_02.png" style="height:180px; border-radius: 10px;"></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>자동 전격 방지 장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>
                              자동 전격 방지 장치가 부착(내장)되어 있을 것<br>
                              (산업안전공단 형식 승인 外)
                            </div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>케이블 커넥터</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접단지 부위의 접속은 커넥터 또는 절연 Tape로 마감되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>케이블 피복은 노출되지 않을 것(케이블 손상이 없을 것)</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>용접홀더</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 홀더의 재질은 비전도성일 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접봉의 탈착 또는 제거가 쉬울 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>접지장치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지용 클럼프가 설치되어 있을 것</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>클럼프의 외관상 변형이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>기타</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용접 작업 보호 장비 : 헬멧, 핸드 쉴드, 장갑, 부착포 등 차폐막을 구비할 것</div>
                          </div>
                        </td>                          
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="24" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="24">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">안전 작업 허가제 - 공구 검수 항목</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">가스용접기</strong>        
              <v-row class="mt-n15">
                <v-col cols="12" md="3">
                  <div class="iron_center_contents"  style="width:inherit; height: 320px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_03.jpg" style="height:180px; border-radius: 10px;"></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>Main V/V</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>용기 개방 Main V/V가 설치되어 있을 것(보호용 CAP 포함)</div>
                          </div>
                          <div class="d-flex">
                            -&nbsp;
                            <div>밸브 핸들의 이탈 및 파손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>압력계</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>압력계의 변형이 없을 것 / 정상 작동 여부는 현장 점검 시 진행</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>액화 방지기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>액화 방지기는 부착되어 있을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">4</td>
                        <td>각 호스</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>호스의 변형 및 훼손이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                      <tr>
                        <td style="width: 10px;">5</td>
                        <td>도치</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>토치 배관 內 막힘 현상 等 이물질이 없을 것</div>
                          </div>
                        </td>
                      </tr>       
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">전기 공구</strong>        
              <v-row class="mt-n2">
                <v-col cols="12" md="3">
                  <div class="iron_center_contents" style="width:inherit; height: 200px;">
                    <div class="iron_center_contents"><img src="../assets/safe_tool_04.jpg" style="height:120px; border-radius: 10px;"></div>    
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <table class="type09 text-center text_first_font">
                    <thead>
                      <tr>
                        <th scope="cols" style="width: 10px;">No</th>
                        <th scope="cols">항목</th>
                        <th scope="cols">검수 기준</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 10px;">1</td>
                        <td>전선(피복 상태)</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>전선 피복의 훼손이 없을 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">2</td>
                        <td>콘센트 Type</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>접지 가능한 3P Type의 접지형일 것</div>
                          </div>
                        </td>                          
                      </tr>
                      <tr>
                        <td style="width: 10px;">3</td>
                        <td>차단기</td>
                        <td class="text-left">
                          <div class="d-flex">
                            -&nbsp;
                            <div>누전 차단기가 있을 것</div>
                          </div>
                        </td>                          
                      </tr>                        
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>    
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <!-- <strong class="deep-orange--text font-weight-black" style="z-index:10;!important">전기 그라인더 등(회전 기계)</strong> -->
              <div class="deep-orange--text font-weight-black mb-4" style="float:flex">전기 그라인더 등(회전 기계)</div>
              <div class="d-flex flex-wrap iron_center_contents">
                <img src="../assets/safe_tool_07.jpg" style="height:130px; border-radius: 10px;">
                <img src="../assets/safe_tool_06.jpg" style="height:130px; border-radius: 10px;">
              </div>
              
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="25" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="25">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 중점 관리 수칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong></div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시</div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong></div>
              </div>
              <div class="d-flex">
                4.&nbsp;
                <div>작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저</div>
              </div>
              <div class="d-flex">
                5.&nbsp;
                <div>사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)</div>
              </div>
              <div class="d-flex">
                6.&nbsp;
                <div>지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong></div>
              </div>
              <div class="d-flex">
                7.&nbsp;
                <div>현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개</div>
              </div>
              <!-- 1. 안전교육 및 작업허가를 得한 후 작업실시, <strong class="red--text font-weight-black">작업시간 준수</strong><br>
              2. 작업 특성에 맞는 <strong class="red--text font-weight-black">개인용 안전 보호구 착용 후</strong> 작업 실시<br>
              3. 작업책임자 현장 상주 및 <strong class="red--text font-weight-black">임의 작업 금지</strong><br>
              4. 작업 전/후 <strong class="red--text font-weight-black">안전 점검 및 정리 정돈</strong> 철저<br>
              5. 사업장 내 인증된 <strong class="red--text font-weight-black">안전설비 사용</strong>(용접기, 연장선, 안전 보호구 等)<br>
              6. 지정장소 外 <strong class="red--text font-weight-black">흡연 금지</strong><br>
              7. 현장 지적 시 <strong class="red--text font-weight-black">개선 조치 완료 후 </strong>작업 재개 -->
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="26" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="26">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">공통</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>모든 작업은 관리감독자가 현장에 배치되어야 하며, 사전 작업허가를 득하여야 한다.</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>관리감독자는 작업절차 교육, 작업자는 작업절차 준수</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>작업과 관계없는 밸브, 버튼 조작 금지</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>이상 상황 발견 시 관리감독자에게 즉시 보고</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>협착, 전도, 추락, 감전, Chemical/가스 누출 및 접촉에 유의할 것</div>
                </div>
                <div class="d-flex mb-2">
                  6.&nbsp;
                  <div>장비 및 배관 등의 설비에 유해를 가하지 않도록 할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">밀폐공간 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>비상 대기자는 현장에 상주할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>그 외 밀폐공간 안전 작업기준을 준수할 것</div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">화기 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반드시 특별안전 작업허가서 발행 후 작업을 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>작업 전 / 휴식 후 가연성 가스 농도 측정을 반드시 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>불티 비산 대비책을 수립하여 시행하고 화기 감시자를 배치할 것</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>주변 가연물 제거 및 소화기를 비치 후 작업할 것</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="27" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="27">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">작업 안전 수칙 - 유형별 작업 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">고소 작업(사다리 포함)</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>반입되는 사다리는 모두 Outtrigger가 설치된 것을 사용</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>사다리 작업 시 2인 1조로 작업을 실시</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>이동식 고소 작업대는 반입 전 검사를 득하고 반입(안전관리팀)</div>
                </div>
                <div class="d-flex mb-2">
                  4.&nbsp;
                  <div>고소 작업 시 반드시 안전벨트 및 걸이대를 설치 후 작업</div>
                </div>
                <div class="d-flex mb-2">
                  5.&nbsp;
                  <div>비계(고정식, 이동식) 사용 시 설치 후 환경안전팀의 승인을 득한 다음 사용</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">정전 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>전기작업은 담당자만 실시할 것</div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>시건장치를 하고, 작업 전 해당 설비 및 Panel 전원 차단</div>
                </div>
                <div class="d-flex mb-2">
                  3.&nbsp;
                  <div>해당 Panel 시건조치 및 꼬리표 부착</div>
                </div>
              </div>
            </v-card-text>              
            <v-divider class="mb-2"></v-divider>              
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">굴착 작업</strong><br>
              <div class="text_first_font mb-2 mt-2 ml-4">
                <div class="d-flex mb-2">
                  1.&nbsp;
                  <div>
                    허가서 발행 후 굴착 전 굴착 예정지 지하 매설물 확인<br>
                    <div class="d-flex mt-1">
                      -&nbsp;
                      <div>환경안전팀, 공무원, 총무팀 담당자 확인 서명 후 작업 진행</div>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  2.&nbsp;
                  <div>
                    굴착 장소 변은 통제를 실시하고 개구부 관리를 철저히 할 것
                  </div>
                </div>
              </div>
            </v-card-text>              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="28" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="28">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 화재 발생 시</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div><strong class="red--text font-weight-black">"불이야"</strong> 큰 소리로 알리고 신고한다.</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>
                      주변의 소화기로 초기소화를 시도한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>소화기 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    3.&nbsp;
                    <div>
                      초기소화 실패 시에는 <strong class="red--text font-weight-black">신속히 대피한다.</strong><br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>비상구 위치는 평소에 알아둔다.</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    4.&nbsp;
                    <div>
                      낮은 자세로 코와 입을 막고 대피한다.<br>
                      <div class="d-flex">
                        ※&nbsp;
                        <div>엘리베이터 사용 금지 / 계단 이용</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    5.&nbsp;
                    <div>화재 상황을 보고한다. (육하원칙)</div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <div class="iron_center_contents" style="width:inherit; height:350px;"><img src="../assets/SKMP.svg" style="height:300px"></div>
              </v-col>
            </v-row>

            <div class="ma-4">
              <div class="box_2 education_content pa-5">
                비상 대피는 빠른 대피보다 <strong class="white--text font-weight-black ml-4 mr-4">"정확한"</strong> 대피가 우선입니다.
              </div>
            </div>

            
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="d-flex">
                1.&nbsp;
                <div>화재를 발견하면 '불이야'하고 큰 소리로 외쳐서 다른 사람에게 알립시다.</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>
                  방재센터로 신고합니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>"본관 2층 휴게실에서 화재가 발생했습니다."</div>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                3.&nbsp;
                <div>
                  화재경보 비상벨을 누릅니다.<br>
                  <div class="d-flex">
                    -&nbsp;
                    <div>평소 주위에 있는 소화기, 옥내소화전 사용법을 숙지했다가 초기에 진화합니다.</div>
                  </div>
                </div>
              </div>
            </v-card-text>              
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="29" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="29">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 소화 기구 사용법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">소화기 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">                       
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;">
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_1.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      안전핀을 뽑는다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_2.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      노즐을 빼고<br>불을 향한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_3.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      레버를 누른다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4 ma-4 text-center">
                  <div>
                    <img src="../assets/fire_tool_4.png" style="height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-40px; height:0px; ">
                      바람을 등지고<br>분사한다
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-150px; width:30px; height:30px; padding-top: -10px;">4</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">옥내 소화전 사용 방법</strong><br>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">         
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">1</div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;">
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">2</div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;">
                    <div class="text-center" style="margin-top:-60px;margin-bottom:10px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                  </div>  
                </v-card>
                <v-card flat class="iron_center_contents circle_Box4_longtext ma-4 text-center">
                  <div>
                    <div class="circle_Box mr-2" style="background-color: #F44336;position: relative;top:-10px; left:20px;">3</div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-30px; height:140px; border-radius: 100px;">
                    <div class="text-center" style="margin-top:-40px;margin-bottom:10px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                  </div>  
                </v-card>
                <!-- <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_5.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-57px; height:0px; padding:20px;">
                      발신기 스위치를 누른다. 소화전 문을 열고 관창과 호스를 꺼낸다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">1</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_6.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-77px; height:0px; padding:20px;">
                      다른 사람은 접힌 호스를 펴주고 관창을 가지고 간 사람이 방수 준비가 되면 밸브를 개방한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">2</div>
                  </div>  
                </div>
                <div class="iron_center_contents circle_Box4_longtext ma-4 text-center" style="width:280px;height:250px;">
                  <div>
                    <img src="../assets/fire_tool_7.png" style="position: relative; top:-10px; height:140px; border-radius: 100px;"/>
                    <div class="text-center" style="position: relative; top:-37px; height:0px; padding:20px;">
                      관창을 잡고 불이 난 곳에 집중하여 진화한다.
                    </div>  
                    <div class="circle_Box mr-2" style="background-color: #F44336; position: relative; top:-200px; left:20px; width:30px; height:30px; padding-top: -10px;">3</div>
                  </div>  
                </div> -->
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="30" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="30">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 환자 발생</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" sm="12" class="pa-0">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <strong class="deep-orange--text font-weight-black">환자 발생 시</strong><br>
                    <div class="text_first_font mb-2 mt-2 ml-4">
                      <div class="d-flex mb-2">
                        1.&nbsp;
                        <div>침착하게 상황을 알리고 신고한다.</div>
                      </div>
                      <div class="d-flex mb-2">
                        2.&nbsp;
                        <div>
                          환자의 상태를 확인하고 안정에 힘쓴다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>호흡 유무, 맥박 상태, 출혈 여부 등</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        3.&nbsp;
                        <div>
                          구호대 또는 구급차 요원에게 인계한다.<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>사고 현장 출입 통제 & 현장보존</div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        4.&nbsp;
                        <div>
                          의료기관으로 긴급 후송한다.<br>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        5.&nbsp;
                        <div>
                          사고 상황을 보고한다. (육하원칙)<br>
                          <div class="d-flex mt-1">
                            ※&nbsp;
                            <div>유선(즉시), 서면(24Hr이내)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>                 
                </v-col>
                <v-col cols="12" md="7" sm="12">
                  <div class="iron_center_contents flex-wrap d-flex" style="width:inherit; max-height:520px;">
                    <img src="../assets/ambulance.jpg" style="max-height:180px;height:80%;">
                    <img src="../assets/fire_center_logo.png" style="height:300px;" />
                    <!-- <div class=" text-center">
                      <img src="../assets/ambulance.jpg" style="height:220px"/>
                      <img src="../assets/fire_center_logo.png" style="height:300px;"/>
                    </div> -->
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
              
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="31" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">비상 대응 절차 - 비상시 대피 방법</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text font-weight-black">비상 대피는 언제, 어디로 하는가?</strong><br>
              <div class="d-flex">
                -&nbsp;
                <div>비상 방송 / 싸이렌 / 화재 / Gas Leak 등의 상황 전파 시 사업장 내 관리자의 지시에 따라 지정된 장소로 대피한다.</div>
              </div>
              <div class="d-flex">
                1.&nbsp;
                <div>피해범위 산정</div>
              </div>
              <div class="d-flex ml-6">
                1)&nbsp;
                <div>화재폭발(Silane, SIH4): 163m</div>
              </div>
              <div class="d-flex ml-6">
                2)&nbsp;
                <div>누출확산(Silane, SIH4): 488m</div>
              </div>
              <div class="d-flex">
                2.&nbsp;
                <div>집결지 선정</div>
              </div>
              <div class="d-flex ml-6">
                1)&nbsp;
                <div>1차 집결지(사내): 행복동 앞 공터</div>
              </div>
              <div class="d-flex ml-6">
                2)&nbsp;
                <div>2차 집결지(사외): 청리산업단지 입구 다리 밑</div>
              </div>
            </v-card-text>              
            <!-- <div class="iron_center_contents" style="width:inherit;"><img src="../assets/safe_map.png" style="height:500px; border-radius: 20px;"/></div> -->
            <div class="iron_center_contents" style="width:inherit;">
              <template>
                <img src="../assets/safe_map.png" style="width:100%;max-width:858px; border-radius: 20px;">
              </template>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="32" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">SHE 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">                
              {{$store.state.CustomInfo.SiteNm}}은(는) 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원과 이해관계자가 신뢰하는 안전하고 행복한 일터를 만들기 위해 다음 사항을 적극 실천한다.
            </v-card-text>              
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 조성</strong><br>
                  SHE 경영체계를 지속적으로 개선하여 구성원, 지역사회, 고객 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장을 함께 만들어간다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>친환경 가치 추구</strong><br>
                  친환경적 설계, 자원의 효율적 사용, 화학물질의 철저한 관리를 통해 사업장과 지역사회의 환경을 보호하고, 선제적으로 온실가스를 감축함으로써 전 지구적 기후변화 위기에 적극적으로 대응한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong>준법 경영 및 투명한 정보공개</strong><br>
                  SHE 법규, 사규 및 이해관계자의 요구사항을 준수하고, 투명한 정보공개를 통해 이해관계자의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>구성원 참여</strong><br>
                  모든 구성원은 인간과 환경 보호를 최우선 가치로 인식하고, 보다 안전하고 건강한 사업장을 만들기 위해 적극적으로 동참한다.
                </div>
              </div>
            </v-card>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="33" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="33">
          <!-- <v-card class="mb-12 mt-n4 mx-auto my-12" min-height="520" flat  > -->
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">사고 예방 4대 원칙</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            
            <v-card :height="ChangableHeight" v-resize="onResize" class="ma-5 education_content lineHeight2" flat>
              <v-img src="@/assets/industry_back.jpg" style="opacity:0.1;border-radius: 20px; box-shadow: 0px 0px 15px 15px #C0C0C0;height:100%"></v-img>
              <div class="safe_4_rules pa-4" id="safe_4_rules_content">
                <div class="d-flex">
                  1.&nbsp;
                  <div>손실 우연의 법칙<br>사고의 결과로써 생긴 재해손실은 우연에 의해 결정된다.</div>
                </div>
                <div class="d-flex">
                  2.&nbsp;
                  <div>재해 발생은 반드시 원인이 있다.<br>즉 사고와 손실과의 관계는 우연적이지만 원인관계는 필연적인 계기가 있다.</div>
                </div>
                <div class="d-flex red--text">
                  3.&nbsp;
                  <div>예방가능의 원칙<br>재해 발생 원칙적으로 근원적인 원인만 제거하면 예방 가능하다.</div>
                </div>
                <div class="d-flex">
                  4.&nbsp;
                  <div>대책 선정의 원칙(기술, 교육, 규제)</div>
                </div>
                <v-card-text class="education_content lineHeight2 text-center font-weight-black">
                  모든 사고는 <strong class="red--text text--lighten-1">예방</strong>할 수 있다.
                </v-card-text>
              </div>
            </v-card>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn v-show="e1 == 1" @click="$emit('CloseEdu')" text width="100"><v-icon>mdi-close</v-icon>취소</v-btn>
      <v-btn v-show="e1 != 1" text width="100" @click="PreviewPage()"><v-icon>mdi-chevron-left</v-icon>뒤로</v-btn>
      <v-btn v-show="e1 != 33" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-show="e1 == 33" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
    </v-card-actions>
  </v-card>    
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
  },
  data: () => ({
    e1: 1,
    ChangableHeight : "",
  }),

  props: {
    oCustomInfo: {
      type: Object,
      default () {
        return {}
      },
    },
  },

  computed: {
    ...mapState(["sNowYear","sNowMounth","sNowDate"]),
  },

  mounted() {
    this.$nextTick(() => {
  try {
    const element = document.getElementById("1");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  } catch (e) {
    // 오류 발생 시에도 콘솔에 아무것도 출력 안 하고 조용히 무시
  }
});

  },

  methods: {
    onResize(){
      if (window.innerWidth > 1350) {
        this.ChangableHeight = "calc(90vh - 225px)"
      } else if (window.innerWidth > 950 && window.innerWidth <= 1350) {
        this.ChangableHeight = "calc(90vh - 250px)"
      } else {
        this.ChangableHeight = String(document.getElementById('safe_4_rules_content').clientHeight) + "px"
      }
    },

    PreviewPage(){
      this.e1 -= 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })
    },

    NextPage(){
      this.e1 += 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })

      if (this.e1 == 33) {
        setTimeout(() => {
          this.onResize();
        }, 10);
      }
    },
  }
};
</script>

<style scoped lang="scss">
  @import "../publishing/visit.scss";

  .box_2{
    width : inherit;    
    border-radius: 20px;    
    color: #FFEB3B;
    background-color: #F44336;
    text-align: center;    
  }
  .box_3{
    width : 350px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_4{
    width : 500px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_outlined{
    width : 300px;
    height : 200px;
    border-radius: 10px;    
    outline: solid;
    outline-color: #AAAAAA;
    outline-width: 1px;
    background-color: #f0f0f0;
    text-align: center;    
  }
  .circle_Box{    
    width : 32px;
    height : 32px;
    border-radius: 100px;    
    color : white;
    background-color: #000088;
    text-align: center;    
  }
  .circle_Box2{
    width : 170px;
    height : 170px;
    border-radius: 100px;        
    background-color: #EEEEEE;
    padding-top: 20px;
    text-align: center;    
  }
  .square_Box{
    width : 160px;
    height : 100px;
    border-radius: 10px;        
    background-color: #eb854a;
    padding-top: 10px;
    text-align: center;    
  }

  .square_Box2{
    width : 250px;
    height : 120px;
    border-radius: 10px;        
    background-color: #EEEEEE;
    padding-top: 10px;
    text-align: center;    
  }

  .circle_Box4{
    width : 190px;
    height : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3; 
  }
  .circle_Box4_longtext {
    max-width : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3;
  }
  .circle_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .circle_Box3{
    width : 160px;
    height : 160px;
    border-radius: 100px;        
    background-color: #F44336;
    padding-top: 20px;
    text-align: center;    
  }
  .lineHeight2{
    line-height: 180%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }

  table.type09 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type09 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type09 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type09 td {
    width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type10 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type10 thead th {
    padding: 11px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type10 body th {
    width: 350px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    
  }
  table.type10 td {
    width: 500px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
    font-size: 18px;
  }
  
  table.type11 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type11 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type11 tbody th {
    max-width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type11 td {
    max-width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type11 td.img_area {
    max-width: 400px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }


  table.type12 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width: 100%;
    vertical-align: middle;
  }

  table.type12 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    border-bottom: 1px solid #ccc; 
    border-top: 1px solid rgb(141, 141, 141);
    border-right: 1px solid #ccc; 
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 td {
    width: 350px;
    padding: 10px;
    vertical-align: center;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  .safe_4_rules {
    position : absolute;
    top : 0px;
    left : 0px;
    width : 100%;
  }

  .table_line_right {
    border-right: 1px solid #ccc;
  }

  .superscript {
    vertical-align: super;
    font-size: 12px;
  }

  .pledge_content {
    overflow:auto;
    @media screen and (min-width: 1065px) {
      width: 100%;
      height:calc(90vh - 155px);

      :deep(.v-card__text) {
        letter-spacing: .0125rem;
        font-size: 1.25rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .009375rem;
        font-size: 1rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 1064px){
      height:calc(90vh - 135px);

      :deep(.v-card__text) {
        // background-color : blue;
        letter-spacing: .01rem;
        font-size: 1rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        // background-color : green;
        letter-spacing: .009375rem;
        font-size: 0.9rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (max-width: 601px) {
      height:calc(90vh - 115px);
      :deep(.v-card__text) {
        letter-spacing: .0075rem;
        font-size: 0.9rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .007rem;
        font-size: 0.8rem;
        font-weight: 400;
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }



</style>
